import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PublicMobileMenu } from '@/components/PublicMobileMenu';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FEATURES = [
  { icon: '💬', c: '#4a3aa8', title: 'ملاحظاتك', desc: 'أخبرنا بما يمكن تحسينه في المنصة' },
  { icon: '💡', c: '#e0a21b', title: 'اقتراحاتك', desc: 'شاركنا أفكارك لميزات جديدة' },
  { icon: '💗', c: '#dd5f7a', title: 'تشجيعك', desc: 'كلمة طيبة منك تعني لنا الكثير' },
];

const FeedbackPage = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sending, setSending] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [bad, setBad] = useState({});

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const handleSubmit = async () => {
    const b = {};
    if (!form.name.trim()) b.name = true;
    if (!/^\S+@\S+\.\S+$/.test(form.email)) b.email = true;
    if (form.message.trim().length < 5) b.message = true;
    setBad(b);
    if (Object.keys(b).length) { setError('يرجى تعبئة الحقول بشكل صحيح'); return; }
    setError('');
    setSending(true);
    try {
      await axios.post(`${API_URL}/api/feedback`, form);
      setSubmitted(true);
    } catch {
      toast.error('فشل في إرسال الرسالة، حاول مرة أخرى');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fbpage" dir="rtl">
      {/* Header matching the provided design */}
      <header className="nav public-page-header" data-testid="public-page-header">
        <Link to="/" className="logo" data-testid="logo-link">RasheedGPT</Link>
        <ul className="public-desktop-navigation" data-testid="public-desktop-navigation">
          <li><Link to="/" data-testid="public-desktop-link-home">الرئيسية</Link></li>
          <li><Link to="/founder" data-testid="public-desktop-link-founder">المؤسس</Link></li>
          <li><Link to="/how-it-works" data-testid="public-desktop-link-how-it-works">كيف يعمل</Link></li>
          <li><Link to="/subscribe" data-testid="public-desktop-link-subscribe">اشترك معنا</Link></li>
          <li><Link to="/feedback" className="cur" aria-current="page" data-testid="feedback-nav-active">رأيك يهمنا</Link></li>
          <li><Link to="/login" className="lg" data-testid="public-desktop-link-login">تسجيل الدخول</Link></li>
        </ul>
        <Link to="/login" className="lmob" data-testid="mobile-login-btn">تسجيل الدخول</Link>
        <PublicMobileMenu />
      </header>

      {/* Decorative rings */}
      <div className="rings" aria-hidden="true"><i></i><i></i><i></i></div>

      <main data-testid="feedback-page">
        {/* Left intro */}
        <section>
          <span className="badge">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1l11 11-11 11L1 12z" /></svg>
            رأيك يهمنا
          </span>
          <h1>بنحب <span>نسمع رأيك</span></h1>
          <p className="lead">سواء كانت ملاحظة، اقتراحًا، أو كلمة تشجيع — كل رأي يساعدنا على بناء منصة أفضل لأبنائنا.</p>
          <div className="fs">
            {FEATURES.map((f, i) => (
              <div key={i} className="f" style={{ '--i': i, '--c': f.c }}>
                <div className="o">{f.icon}</div>
                <div><h3>{f.title}</h3><p>{f.desc}</p></div>
              </div>
            ))}
          </div>
        </section>

        {/* Right card */}
        <section className="card">
          {submitted ? (
            <div className="ok" data-testid="feedback-success">
              <div className="big"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg></div>
              <h2>وصلتنا رسالتك، شكرًا لك</h2>
              <p className="sub">رأيك يصنع الفرق في رحلة تعلّم أبنائنا.</p>
            </div>
          ) : (
            <div>
              <h2>أرسل لنا رسالة من قلبك<span className="heart" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 21s-8-5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 6-8 11-8 11z" /></svg></span></h2>
              <p className="sub">نقرأ كل رسالة ونردّ عليك بأسرع وقت.</p>

              <div className="two">
                <div>
                  <label htmlFor="fb-n">الاسم</label>
                  <input id="fb-n" className={bad.name ? 'bad' : ''} value={form.name} onChange={set('name')} placeholder="أدخل اسمك" data-testid="feedback-name-input" />
                </div>
                <div>
                  <label htmlFor="fb-e">البريد الإلكتروني</label>
                  <input id="fb-e" type="email" dir="ltr" style={{ textAlign: 'right' }} className={bad.email ? 'bad' : ''} value={form.email} onChange={set('email')} placeholder="example@email.com" data-testid="feedback-email-input" />
                </div>
              </div>

              <label htmlFor="fb-m">رسالتك</label>
              <textarea id="fb-m" maxLength={500} className={bad.message ? 'bad' : ''} value={form.message} onChange={set('message')} placeholder="شاركنا ملاحظاتك أو اقتراحاتك..." data-testid="feedback-message-input" />
              <div className="frow">
                <span className="err" data-testid="feedback-error">{error}</span>
                <span>{form.message.length} / 500</span>
              </div>

              <button className="sendbtn" onClick={handleSubmit} disabled={sending} data-testid="feedback-submit-btn">
                {sending ? 'جارٍ الإرسال...' : 'إرسال الرسالة'}
              </button>
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

export default FeedbackPage;
